import { Injectable } from '@angular/core';

/** Scribe listing UI state persisted across encounter navigation. */
export interface ScribeListUiState {
  searchQuery: string;
  currentPage: number;
  pageSize: number;
  startDate: string;
  endDate: string;
  selectedServices: string[];
  selectedProviders: string[];
  selectedNoteStatuses: string[];
  selectedClaimStatuses: string[];
}

@Injectable({ providedIn: 'root' })
export class ScribeListStateService {
  private state: ScribeListUiState | null = null;

  save(state: ScribeListUiState): void {
    this.state = {
      searchQuery: state.searchQuery ?? '',
      currentPage: state.currentPage ?? 0,
      pageSize: state.pageSize ?? 25,
      startDate: state.startDate ?? '',
      endDate: state.endDate ?? '',
      selectedServices: [...(state.selectedServices ?? [])],
      selectedProviders: [...(state.selectedProviders ?? [])],
      selectedNoteStatuses: [...(state.selectedNoteStatuses ?? [])],
      selectedClaimStatuses: [...(state.selectedClaimStatuses ?? [])],
    };
  }

  peekState(): ScribeListUiState | null {
    if (!this.state) {
      return null;
    }
    return {
      ...this.state,
      selectedServices: [...this.state.selectedServices],
      selectedProviders: [...this.state.selectedProviders],
      selectedNoteStatuses: [...this.state.selectedNoteStatuses],
      selectedClaimStatuses: [...this.state.selectedClaimStatuses],
    };
  }

  clear(): void {
    this.state = null;
  }
}
